import {HOVER_COLOR, ProcessNodeEditor} from "./ProcessNodeEditor";
import {BoxedObjectEditor} from "./BoxedObjectEditor";

export const EVENT_WIDTH = 40;
export const EVENT_HEIGHT = 40;

export class EventEditor extends ProcessNodeEditor {
	constructor(parent, node, coords) {
		super(parent, node, coords, false);
	}

	get bg() {
		return this.hovered ? HOVER_COLOR : "#EDFFF0";
	}

	get nameY() {
		return super.nameY + this.coords.h/2 + 10;
	}

	get nameVAlign() {
		return "top";
	}

	draw(ctx) {
		ctx.save();
		ctx.strokeStyle = this.selected ? S.HI_COLORS[8] : "black";
		ctx.fillStyle = this.bg;
		const lw = this.lineWidth;
		ctx.lineWidth = lw;
		ctx.beginPath();
		ctx.ellipse(this.coords.x, this.coords.y, (this.coords.w - lw) / 2, (this.coords.h - lw) / 2, 0, 0, 2 * Math.PI);
		ctx.fill();
		ctx.stroke();
		ctx.restore();

		const rect = BoxedObjectEditor.strokeBox(this.coords.x, this.coords.y, this.coords.w, this.coords.h, lw);
		this.drawNodeName(ctx, rect);
	}


	drawNodeName(ctx, rect) {
		rect.width = 100;
		super.drawNodeName(ctx, rect);
	}

	calcIncomingArrowTip(angle) {
		const r = Math.max(this.coords.w, this.coords.h)/2;
		return {
			tipX : Math.cos(angle+Math.PI)*r + this.coords.x,
			tipY : Math.sin(angle+Math.PI)*r + this.coords.y,
			angle : angle
		};
	}
}